<template>
  <div v-if="showType==='box'">
    <a-button type="primary" @click="$emit('addMore')" class="m_r_15">多客户端批量设置内容</a-button>
    <a-popover title="请选择要群发的机器人" trigger="click">
      <template slot="content">
        <div style="width:600px">
          <robot-multiple @change="robotChange" @returnBack="robotReturnBack"></robot-multiple>
          <div  class="m_t_15 d_f f_r">
            <a-button type="primary" :loading="startLoading" :disabled="false" @click="handleMoreStart">开始推送</a-button>
          </div>
        </div>
      </template>
      <a-button type="primary" :loading="startLoading" :disabled="false" class="m_r_15" @click="changeType('start')">多客户端批量开始群发</a-button>
    </a-popover>
    <a-popover title="请选择要暂停群发的机器人" trigger="click">
      <template slot="content">
        <div style="width:600px">
          <robot-multiple @change="robotChange" @returnBack="robotReturnBack"></robot-multiple>
          <div  class="m_t_15 d_f f_r">
            <a-button type="primary" :loading="startLoading" :disabled="false" @click="handleMorePause">开始推送</a-button>
          </div>
        </div>
      </template>
          <a-button type="warning" :loading="pauseLoading" :disabled="false" class="m_r_15" @click="changeType('pause')">多客户端批量暂停群发</a-button>
    </a-popover>
    <a-popover title="请选择要清空群发列表的机器人" trigger="click">
      <template slot="content">
        <div style="width:600px">
          <robot-multiple @change="robotChange" @returnBack="robotReturnBack"></robot-multiple>
          <div  class="m_t_15 d_f f_r">
            <a-button type="primary" :loading="startLoading" :disabled="false" @click="handleMoreClear">开始推送</a-button>
          </div>
        </div>
      </template>
      <a-button type="danger" :loading="clearLoading" class="m_r_15" @click="changeType('clear')">多客户端批量清空列表</a-button>
    </a-popover>
  </div>
  <span v-else>
    <a-button type="link" style="padding:0" @click="$emit('edit')" :disabled="editDisable">
      内容设置
    </a-button>
    <a-divider type="vertical" />
    <a-button type="link" style="padding:0" :loading="startLoading" :disabled="startDisable" @click="handleStart">开始群发</a-button>
    <a-divider type="vertical" />
    <a-button type="link" style="padding:0" :loading="pauseLoading" :disabled="pauseDisable" @click="handlePause">暂停群发</a-button>
    <a-divider type="vertical" />
    <a-popconfirm placement="topRight" ok-text="确定" cancel-text="取消" @confirm="handleClear">
      <template slot="title">
        确认要清空发送对象吗？已发送的粉丝再次添加进来会再次发送哦！
      </template>
      <a-button type="link" style="padding:0" :loading="clearLoading">清空发送对象</a-button>
    </a-popconfirm>
  </span>
</template>

<script>

import RobotMultiple from '@/views/components/RobotMultiple'
import GrouppushApi from '@/api/grouppush'
import {mapActions} from 'vuex'
function handleMoreClear(){
  this.BatchpushTask({
    robotids: this.clearList,
    descs: '群发任务',
    apiFun:(sub_id) => {
    return GrouppushApi.clearList({
        sub_id: sub_id
      })
    }
  })
  this.TaskDrawerSwitch({status:true})
}
function handleMorePause(){
  this.BatchpushTask({
    robotids: this.pauseList,
    descs: '群发任务',
    apiFun:(sub_id) => {
    return new Promise(async(resolve,reject)=>{
      const { data } = await GrouppushApi.getTask({
        sub_id: sub_id
      })
      const res = await GrouppushApi.addTask({
        ...data,
        sub_id: sub_id,
        status:4
      })
      resolve(res)
      })
    }
  })
  this.TaskDrawerSwitch({status:true})
}
function handleMoreStart(){
  this.BatchpushTask({
    robotids: this.startList,
    descs: '群发任务',
    apiFun:(sub_id) => {
    return new Promise(async(resolve,reject)=>{
      const { data } = await GrouppushApi.getTask({
        sub_id: sub_id
      })
      const res = await GrouppushApi.addTask({
        ...data,
        sub_id: sub_id,
        status:1
      })
      resolve(res)
      })
    }
  })
  this.TaskDrawerSwitch({status:true})
}
function handleStart() {
  this.startLoading = true
  this.getData()
  setTimeout(()=>{
    GrouppushApi.addTask({
      ...this.task,
      status: 1
    }).then(({ code, msg }) => {
      if (code === 1) {
        setTimeout(() => {
          this.getData()
        }, 2000)
        return this.$message.success('操作成功')
      }
      this.$emit('reload')
      this.$message.error(msg)
    }).finally(() => { this.startLoading = false })
  },800)
}
function handlePause() {
  this.pauseLoading = true
  GrouppushApi.addTask({
    ...this.task,
    status: 4
  }).then(({ code, msg }) => {
    if (code === 1) {
      this.getData()
      return this.$message.success('操作成功')
    }
    this.$message.error(msg)
  }).finally(() => {
    this.pauseLoading = false
  })
}
function handleRefresh () {
  this.$emit('reload')
  this.getData()
}
function handleClear() {
  this.clearLoading = true
  GrouppushApi.clearList({
    sub_id: this.subId
  }).then(({ code, msg }) => {
    if (code === 1) {
      this.$emit('reload')
      return this.$message.success('操作成功')
    }
    this.$message.error(msg)
  }).finally(() => {
    this.clearLoading = false
  })
}

async function getData() {
  if (!this.subId) return
  const { data } = await GrouppushApi.getTask({
    sub_id: this.subId
  })
  this.task = {
    ...data,
    sub_id: this.subId
  }
}

const props = {
  subId: {
    type: Number | String,
    default: 0
  },
  showType:{
    type:String,
    default:''
  }
}

export default {
  name: 'ActionsBoxVue',
  data: () => {
    return {
      task: null,
      startLoading: false,
      pauseLoading: false,
      clearLoading: false,
      timer: null,
      startList:[],
      pauseList:[],
      clearList:[],
      allType:''
    }
  },
  components:{
    RobotMultiple
  },
  destroyed() {
    this.timer && clearInterval(this.timer)
  },
  computed: {
    editDisable() {
      if (this.task) {
        const { status } = this.task
        return (Number(status) === 1 || Number(status) === 2)
      } else {
        return true
      }
    },
    startDisable() {
      if (this.task) {
        const { status } = this.task
        return status === 2
      } else {
        return true
      }
    },
    pauseDisable() {
      if (this.task) {
        const { status } = this.task
        return Number(status) !== 2 || Number(status) === 0
      } else {
        return true
      }
    },
    clearDisable() {
      if (this.task) {
        const { status } = this.task
        return Number(status) === 2
      } else {
        return true
      }
    }
  },
  props,
  created() {
    this.getData()
  },
  watch: {
    subId() {
      this.getData()
    }
  },
  methods: {
    ...mapActions(['TaskDrawerSwitch', 'BatchpushTask']),
    handleStart,
    handlePause,
    handleClear,
    getData,
    handleRefresh,
    handleMoreStart,
    handleMorePause,
    handleMoreClear,
    robotChange(List){
      switch(this.allType){
        case 'start':
          this.startList = Array.from(List);
          break
        case 'pause':
          this.pauseList = Array.from(List);
          break
        case 'clear':
          this.clearList = Array.from(List)
          break
        default:
          this.$message.warning('未知操作类型')
      }
    },
    robotReturnBack(List){
      switch(this.allType){
        case 'start':
          this.startList = Array.from(List);
          break
        case 'pause':
          this.pauseList = Array.from(List);
          break
        case 'clear':
          this.clearList = Array.from(List)
          break
        default:
          this.$message.warning('未知操作类型')
      }
    },
    changeType(type){
      this.allType = type
    }

  }
}
</script>

<style scoped>
.ant-alert{
  display: inline-block;
}
.m_r_15{
  margin-right: 15px;
}
.m_t_15{
  margin-top: 15px;
}
.d_f{
  display: flex;
}
.f_r{
  justify-content: flex-end;
}
</style>
